"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = __importStar(require("../message/Message"));
const InviteActions_1 = __importDefault(require("../../actions/InviteActions"));
const InviteContainer_1 = __importDefault(require("./InviteContainer"));
const InviteStageStyled_1 = __importDefault(require("./InviteStageStyled"));
const react_router_dom_1 = require("react-router-dom");
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const SquareButton_1 = __importDefault(require("../squareButton/SquareButton"));
const classnames_1 = __importDefault(require("classnames"));
const route_1 = require("../../utils/route");
class InviteStage extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            formInput: '',
            errorMessage: ''
        };
        this.handleInput = evt => {
            this.setState({
                formInput: evt.target.value
            });
        };
        this.handleSubmit = () => {
            // validate Email
            const email = this.state.formInput;
            const { isLoggedIn } = this.props;
            InviteActions_1.default.reset();
            if (!this.validateEmail(email)) {
                this.setState({
                    errorMessage: 'epic.code.invite.error.invalid_email'
                });
            }
            else {
                InviteActions_1.default.sendInvite({ email, isLoggedIn });
            }
        };
        this.handleEnterSubmit = evt => {
            if (evt.keyCode === 13) {
                this.handleSubmit();
            }
        };
    }
    componentDidMount() {
        InviteActions_1.default.getCurrentInvites(this.props.isLoggedIn);
        InviteActions_1.default.getPrevPath();
    }
    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    render() {
        let inviteStageView;
        if (this.props.inviteStore.loading) {
            inviteStageView = this.props.loadScreen;
        }
        else if (!this.props.inviteStore.currentInvites) {
            const finishLink = this.props.inviteStore.prevPath || route_1.generateRouteTo('/', this.props.location);
            inviteStageView = (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "site-block-header" },
                    react_1.default.createElement("h1", { className: "site-block-title" },
                        react_1.default.createElement(Message_1.default, { code: "epic.code.invite.validate.title" })),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(Message_1.default, { code: "epic.code.invite.error.no_invites" })),
                    react_1.default.createElement("div", { className: "clearfix" })),
                react_1.default.createElement("div", { className: "buttonContainer" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: finishLink, className: "btn btn-primary centered", style: { width: '240px' } },
                        react_1.default.createElement(Message_1.default, { code: "epic.common.finish" })))));
        }
        else {
            const { currentInvites } = this.props.inviteStore;
            const isError = !!this.state.errorMessage || this.props.inviteStore.errorMsg;
            const errorClass = classnames_1.default('errorMessage', { hidden: !isError });
            inviteStageView = (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "site-block-header" },
                    react_1.default.createElement("h1", { className: "site-block-title" },
                        react_1.default.createElement(Message_1.default, { code: "epic.code.invite.send.title" })),
                    react_1.default.createElement("div", { className: "clearfix" })),
                react_1.default.createElement("input", { value: this.state.formInput, type: "text", placeholder: Message_1.localizedMessage('epic.code.invite.validate.input_placeholder'), onChange: this.handleInput, onKeyDown: this.handleEnterSubmit }),
                react_1.default.createElement("div", { className: errorClass },
                    react_1.default.createElement(Message_1.default, { code: this.state.errorMessage }),
                    this.props.inviteStore.errorMsg && !this.state.errorMessage && react_1.default.createElement(Message_1.default, { code: this.props.inviteStore.errorMsg })),
                react_1.default.createElement("p", { className: "text-center" },
                    react_1.default.createElement(Message_1.default, { code: "epic.code.invite.validate.msg", args: [currentInvites] })),
                react_1.default.createElement("div", { className: "buttonContainer" },
                    react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleSubmit, config: { buttonStyle: 'btn-primary', width: '240px', centered: true } },
                        react_1.default.createElement(Message_1.default, { code: "epic.common.invite" })))));
        }
        return (react_1.default.createElement(InviteStageStyled_1.default, { className: "inviteStage" },
            react_1.default.createElement(InviteContainer_1.default, { className: "inviteContainer" },
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: "epic.code.invite.title" })),
                react_1.default.createElement("div", { className: "site-block" }, inviteStageView))));
    }
}
InviteStage.propTypes = {
    inviteStore: prop_types_1.default.object,
    loadScreen: prop_types_1.default.node,
    isLoggedIn: prop_types_1.default.bool,
    location: prop_types_1.default.object
};
exports.default = react_router_dom_1.withRouter(InviteStage);
//# sourceMappingURL=InviteStage.js.map